"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var stimulus_1 = require("stimulus");
var get_or_default_1 = require("@hikakaku/shared/util/get_or_default");
var ScrollToIdController = /** @class */ (function (_super) {
    __extends(ScrollToIdController, _super);
    function ScrollToIdController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.targetId = '';
        _this.extraOffset = -150;
        _this.connect = function () {
            _this.targetId = (0, get_or_default_1.getOrDefault)(_this.data, 'target-id');
            var extraOffset = (0, get_or_default_1.getOrDefault)(_this.data, 'extra-offset');
            if (extraOffset) {
                _this.extraOffset = Number(extraOffset);
            }
        };
        _this.scroll = function () {
            var targetElement = document.getElementById(_this.targetId);
            if (!targetElement) {
                return;
            }
            (0, jquery_1.default)("html, body").animate({
                scrollTop: (targetElement.offsetTop) + _this.extraOffset
            }, 500);
        };
        return _this;
    }
    return ScrollToIdController;
}(stimulus_1.Controller));
exports.default = ScrollToIdController;
